import { createClient } from '@supabase/supabase-js'

/**
 * Public (anon) Supabase client used by athletes and coaches for their own
 * RLS-scoped reads/writes. Operations that need the service-role key (creating
 * logins, invites, billing) go through dedicated Netlify functions instead, so
 * the key is never shipped here.
 *
 * Set these in an `.env` file (VITE_ prefix required by Vite):
 *   VITE_SUPABASE_URL=...
 *   VITE_SUPABASE_ANON_KEY=...
 */
const url = import.meta.env.VITE_SUPABASE_URL as string | undefined
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined

export const supabaseReady = Boolean(url && anonKey)

export const supabase = supabaseReady
  ? createClient(url!, anonKey!, {
      auth: { persistSession: true, autoRefreshToken: true },
    })
  : // Lazy stub so the app can boot before env is wired (Phase 0/1).
    (null as unknown as ReturnType<typeof createClient>)
